import { put, takeLatest } from 'redux-saga/effects';
import qs from 'qs';
import { captureException } from '@sentry/react';

import { coreClient as client } from '@app/helpers/requests/client';
import {
  getResponseData,
  responseSuccess,
} from '@app/helpers/requests/bennieFetch';
import { fetchUsersRequest, fetchUsersSuccess, fetchUsersError } from './index';

export function* requestUsers({ payload: { params } }) {
  // backend is Zero-based
  const pageNumber = params.page ? +params.page - 1 : 0;

  const queryParams = {
    name: params.name,
    pageNumber,
  };

  // A subsidiaryId without a companyId is a programming error, not a
  // signal to fall back to the company-wide list.
  if (params.subsidiaryId && !params.companyId) {
    const error = new Error(
      'requestUsers received subsidiaryId without companyId',
    );
    captureException(error, { tags: { section: 'ManageUsers' } });
    yield put(fetchUsersError({ error: error.message }));
    return;
  }

  const scopedToSubsidiary = !!(params.subsidiaryId && params.companyId);
  const path = scopedToSubsidiary
    ? `/v1/admin/companies/${params.companyId}/subsidiaries/${
        params.subsidiaryId
      }/users`
    : `/v1/admin/users/listusers`;

  try {
    const response = yield client
      .get(`${path}?${qs.stringify(queryParams)}`)
      .catch(error => {
        throw new Error(error);
      });

    let data;

    if (response.status >= 200 && response.status < 300) {
      const { status } = response;

      if (responseSuccess(status)) {
        data = yield getResponseData(response);
      } else if (response.status === 204) {
        data = {};
      }

      yield put(
        fetchUsersSuccess({
          response: data,
          params,
        }),
      );
    } else {
      throw new Error('Error fetching users');
    }
  } catch (error) {
    captureException(error, {
      tags: { section: 'ManageUsers' },
      extra: { scopedToSubsidiary },
    });
    yield put(
      fetchUsersError({
        error: error.message || 'not allowed',
      }),
    );
  }
}

export function* adminRequestUsersWatcher() {
  yield takeLatest(fetchUsersRequest, requestUsers);
}
